import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import InfoIcon from "@mui/icons-material/Info";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import DescriptionIcon from "@mui/icons-material/Description";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import PersonIcon from "@mui/icons-material/Person";

import PaperText from "../../helper-components/misc/PaperText";
import PaperFragment from "../../helper-components/misc/PaperFragment";
import CustomForm from "../../helper-components/form/CustomForm";
import NavigationFooter from "../../helper-components/misc/NavigationFooter";
import CustomButton from "../../helper-components/input/CustomButton.jsx";

import { replacePlaceholdersWithObjValues } from "../../helper-functions/shared/miscUtils.js";

import { getLanguage } from "../../config/language/language.js";

/**
 * A simple "about us" page, which includes what this app in meant to do.
 */
export default function About(props) {
    const status = props.backend.programStatus;

    const isLoggedIn = props.user.isLoggedIn;

    const loggedInOverviewText = replacePlaceholdersWithObjValues(getLanguage().HOME_OVERVIEW_TEXT_1, status);
    const loggedOutOverviewText = replacePlaceholdersWithObjValues(getLanguage().HOME_OVERVIEW_NO_DATA_TEXT_1, status);

    const loggedInOptions = [
        {
            path: `/database/resources`,
            title: "Resources",
            variant: "outlined",
            icon: <DescriptionIcon />
        },
        {
            path: `/database/transcripts`,
            title: "Transcripts",
            variant: "outlined",
            icon: <TextFieldsIcon />
        },
        {
            path: `/database/quotes`,
            title: "Quotes",
            variant: "outlined",
            icon: <FormatQuoteIcon />
        },
        {
            path: `/database/authors`,
            title: "Authors",
            variant: "outlined",
            icon: <PersonIcon />
        }
    ];

    const loggedOutOptions = [
        {
            path: `/home`,
            title: getLanguage().SIDEBAR_OVERVIEW
        },
        {
            path: `/signin`,
            title: getLanguage().BUTTON_SIGNIN,
            variant: "contained"
        }
    ];

    return (
        <Container maxWidth="xl" sx={{ mt: 2, mb: 2 }}>
            {/* Intro text. */}
            <Grid container spacing={1}>
                <Grid item xs={12} className="tour-about-4">
                    <CustomForm title={getLanguage().ABOUT_TITLE} subtitle={getLanguage().ABOUT_SUBTITLE} icon={<InfoIcon />} />
                </Grid>

                <Grid item xs={12}>
                    <PaperText whiteSpace="pre-wrap" value={getLanguage().ABOUT_TEXT_1} />
                </Grid>

                <Grid item sm={12}>
                    <PaperText whiteSpace="pre-wrap" value={getLanguage().ABOUT_TEXT_2} />
                </Grid>

                <Grid item sm={12}>
                    <PaperText whiteSpace="pre-wrap" value={getLanguage().ABOUT_TEXT_3} />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <PaperFragment
                        center
                        value={
                            <>
                                <Typography style={{ whiteSpace: "pre-line" }}>
                                    <img width="95%" src={`${process.env.PUBLIC_URL}/images/atlas_cut.jpg`} alt="Atlas"></img>
                                </Typography>

                                <Typography
                                    sx={{
                                        whiteSpace: "pre-line",
                                        mb: 2,
                                        fontStyle: "italic"
                                    }}>
                                    {getLanguage().ABOUT_TEXT_4}
                                </Typography>
                            </>
                        }
                    />
                </Grid>

                {/* Logged in, and data available. */}
                {isLoggedIn && status && (
                    <Grid item xs={12} sm={8}>
                        <PaperText value={loggedInOverviewText} />
                        <CustomButton {...props} title="Go to Search" path="/home" size="small" fullWidth />
                    </Grid>
                )}

                {/* Not logged in, but public data available. */}
                {!isLoggedIn && status && (
                    <Grid item xs={12} sm={8}>
                        <PaperText value={loggedOutOverviewText} />
                    </Grid>
                )}

                {/* Absolutely no data available. */}
                {!isLoggedIn && !status && (
                    <Grid item xs={12} sm={8}>
                        <PaperText center bold value={getLanguage().HOME_OVERVIEW_NO_DATA_TEXT_2} />
                    </Grid>
                )}

                <NavigationFooter rows={props.user.isLoggedIn ? 3 : 1} options={props.user.isLoggedIn ? loggedInOptions : loggedOutOptions} />
            </Grid>
        </Container>
    );
}
